/**
 * Display-only datetime formatting for Shahoo UI.
 * Always Asia/Tehran (+03:30 permanent). Storage/API stay UTC/unix — no DB change.
 */
import moment from "jalali-moment";

/** Iran standard offset minutes east of UTC (no DST). */
export const TEHRAN_UTC_OFFSET_MINUTES = 210;

export const DISPLAY_PATTERNS = {
  /** e.g. 01 فروردین 1403 | 14:30 */
  full: "DD MMMM YYYY | H:mm",
  /** e.g. 14:30:05 */
  time: "H:mm:ss",
  /** e.g. 01 فروردین 1403 | 14:30:05 */
  fullSeconds: "DD MMMM YYYY | H:mm:ss",
  /** e.g. 1403/01/01 14:30 */
  ymdHm: "jYYYY/jMM/jDD HH:mm",
};

function parseToTehranMoment(value, input) {
  if (value == null || value === "") return null;

  let kind = input || "auto";
  if (kind === "auto") {
    if (typeof value === "number") {
      // Heuristic: < 1e12 → unix seconds; else ms
      kind = value < 1e12 ? "unixSec" : "unixMs";
    } else if (value instanceof Date) {
      kind = "date";
    } else {
      kind = "iso";
    }
  }

  let m;
  switch (kind) {
    case "unixSec":
      m = moment.unix(Number(value)).utc();
      break;
    case "unixMs":
      m = moment.utc(Number(value));
      break;
    case "date":
      m = moment.utc(value.getTime());
      break;
    case "iso":
    default:
      m = moment.utc(String(value));
      break;
  }

  if (!m.isValid()) return null;
  // Force permanent Tehran wall clock (ignore browser TZ / historical DST).
  return m.utcOffset(TEHRAN_UTC_OFFSET_MINUTES).locale("fa");
}

/**
 * @param {string|number|Date} value
 * @param {{ pattern?: keyof typeof DISPLAY_PATTERNS | string, input?: 'auto'|'iso'|'unixSec'|'unixMs'|'date' }} [opts]
 */
export function formatDisplayDateTime(value, opts = {}) {
  const patternKey = opts.pattern || "full";
  const formatStr = DISPLAY_PATTERNS[patternKey] || patternKey;
  const m = parseToTehranMoment(value, opts.input);
  if (!m) return "";
  return m.format(formatStr);
}

export default formatDisplayDateTime;
